<template>
    <div class="patient-edit-semi-original">
        <bread-crumb :bread-list="breadList" />
        <div class="edit-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">编辑半原创</span>
            </div>
            <el-form :model="originalDetails"
                     ref="originalDetails"
                     v-loading="loading"
                     label-width="104px"
                     class="original-form">
                <el-form-item label="原课程链接"
                              prop="url"
                              :rules="[{ required: true, message: '请输入原课程链接', trigger: 'change' }]">
                    <el-input v-model.trim="originalDetails.url"
                              class="from-input"
                              placeholder="请输入原课程链接"
                              maxlength="1500">
                    </el-input>
                    <label class="form-label"
                           @click="handleConfirmUrl">确定</label>
                </el-form-item>

                <el-form-item label="原标题">
                    <span>{{ originalDetails.oldTitle }}</span>
                </el-form-item>

                <el-form-item label="新标题"
                              prop="title"
                              :rules="[{ required: true, message: '请输入新标题', trigger: 'change' }]">
                    <el-input v-model.trim="originalDetails.title"
                              class="from-input"
                              placeholder="请输入URL"
                              maxlength="15">
                    </el-input>
                </el-form-item>

                <el-form-item label="封面图"
                              prop="coverPicture"
                              :rules="[{ required: true, message: '请上传封面图', trigger: 'change' }]">
                    <div v-if="originalDetails.coverPicture"
                         class="cover-content">
                        <el-image fit="fill"
                                  class="cover-picture"
                                  :src="'/ms-hoc-video/v1/image/download?fileName='+ originalDetails.coverPicture">
                        </el-image>
                        <i class="iconfont icon-jinggaochacha"
                           @click="handleRemove"></i>
                    </div>

                    <el-upload v-else
                               v-loading="pictureLoading"
                               class="picture-uploader"
                               :action="uploadAction"
                               :show-file-list="false"
                               accept=".jpg, .png"
                               :on-success="handleSuccess"
                               :before-upload="beforeUpload">
                        <div class="picture-content">
                            <i class="iconfont icon-camera"></i>
                            <div class="picture_text">
                                上传封面图
                            </div>
                        </div>
                    </el-upload>
                    <h1 class="uploader-tips">
                        建议图片小于2M，尺寸：698*280，图片格式为JPG、PNG。
                    </h1>
                </el-form-item>

                <el-form-item label="定时上线"
                              prop="addedTime"
                              :rules="[{ required: true, message: '请输入定时上线', trigger: 'change' }]">
                    <el-date-picker size="small"
                                    clearable
                                    v-model="originalDetails.addedTime"
                                    type="datetime"
                                    placeholder="yyyy-MM-dd HH:mm"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    :style="{width: '320px'}">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"
                               class="submit-btn"
                               @click="submitForm('originalDetails')">提交</el-button>
                    <el-button @click="handleCandle"
                               class="cancle-btn">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { postAnalysisUrl, getByContentId, postContentUpdate } from '@/api/patient/content'
export default {
    name: 'editSemiOriginal',
    data () {
        return {
            breadList: [{ label: '内容管理' }, { label: '内容列表', path: '/patient/content/contentList' }, { label: '编辑半原创' }],
            originalDetails: {},
            loading: false,
            pictureLoading: false,
            linkShow: false,
            contentId: this.$route.query.contentId
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
        uploadAction () {
            return `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=PATIENTCONTENT`
        }
    },
    methods: {
        // 解析链接 URL
        async handleConfirmUrl () {
            let params = {
                url: this.originalDetails.url
            }
            const { results } = await postAnalysisUrl(params)
            if (results) {
                this.linkShow = true
                this.originalDetails.oldTitle = results
            } else {
                this.$message({
                    message: '请检查输入原课程链接是否正确！',
                    customClass: 'hos-message--warning',
                    iconClass: 'el-icon-warning',
                    duration: '2000'
                })
            }
        },
        handleCandle () {
            this.$router.push('/patient/content/contentList')
        },
        beforeUpload (file) {
            this.pictureLoading = true
            const isType = ['jpg', 'jpeg', 'png']
            const fileName = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() // 文件扩展名
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过2MB!')
                this.pictureLoading = false
                return false
            } else if (!isType.includes(fileName)) {
                this.$message.error('请上传' + isType.join(',') + '的文件!')
                this.pictureLoading = false
                return false
            } else {
                return true
            }
        },
        handleSuccess (res, file) {
            const data = res.results
            if (data && data.length > 0) {
                this.originalDetails.coverPicture = data[0].originPictureId
                this.$refs.originalDetails.clearValidate()
            } else {
                this.$message.error('上传出错，请检查上传图片！')
            }
            this.pictureLoading = false
        },
        handleRemove () {
            this.originalDetails.coverPicture = ''
            this.pictureLoading = false
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.hanleSave()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async hanleSave () {
            this.loading = true
            let addedTime = this.originalDetails.addedTime
            if (this.originalDetails.addedTime.length !== 19) {
                addedTime = addedTime + ':00'
            }

            let params = {
                contentId: this.contentId,
                addedTime: addedTime,
                contentType: 'HALF_ORIGINAL',
                coverPicture: this.originalDetails.coverPicture,
                oldTitle: this.originalDetails.oldTitle,
                title: this.originalDetails.title,
                uploader: this.userInfo.accountName,
                url: this.originalDetails.url
            }
            const { results } = await postContentUpdate(params)
            if (results) {
                this.$message({
                    message: '编辑半原创成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.$router.push('/patient/content/contentList')
            } else {
                this.$message.error('编辑半原创失败，请联系管理员！')
            }
            this.loading = false
        },
        async queryContent () {
            this.loading = true
            const { results } = await getByContentId(this.contentId)
            this.originalDetails = results
            this.loading = false
        }
    },
    mounted () {
        this.queryContent()
    }
}
</script>

<style lang="scss">
.patient-edit-semi-original {
    height: 100%;
    .edit-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            padding-bottom: 10px;
            height: 16px;
            line-height: 16px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ccc;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                height: 16px;
                font-family: PingFangSC-Medium;
            }
        }

        .original-form {
            margin-top: 20px;
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .form-label {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #3b8fd9;
                    letter-spacing: 0;
                    line-height: 14px;
                    margin-left: 10px;
                    cursor: pointer;
                }
                .form-span {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 0;
                    text-align: left;
                    line-height: 14px;
                }
                .cover-content {
                    position: relative;
                    .cover-picture {
                        width: 339px;
                        height: 130px;
                    }
                    .icon-jinggaochacha {
                        cursor: pointer;
                        font-size: 16px;
                        color: #ec6a69;
                        position: absolute;
                        top: -15px;
                        left: 330px;
                    }
                }

                .picture-uploader {
                    width: 327px;
                    height: 130px;
                    background: #d8d8d8;
                    text-align: center;
                    .picture-content {
                        margin-top: 40px;
                        .icon-camera {
                            font-size: 24px;
                            color: #fff;
                        }
                        .picture_text {
                            margin-top: 2px;
                            font-family: PingFang-SC-Medium;
                            font-size: 14px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 14px;
                        }
                    }
                }
                .uploader-tips {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                    font-weight: normal;
                    margin-top: 10px;
                }
                .form-datetime {
                    width: 320px;
                    .el-input__inner {
                        height: 32px;
                    }
                    .el-input__prefix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }
                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
